import { gql } from '@apollo/client';

import { QUOTE_FEE_FRAGMENT } from './quoteFeeFragment';
import { QUOTE_REBATE_FRAGMENT } from './quoteRebateFragment';
import { QUOTE_EQUIPMENT_FRAGMENT } from './quoteEquipmentFragment';
import { QUOTE_AFTERMARKET_PRODUCT_FRAGMENT } from './quoteAftermarketProductFragment';
import { QUOTE_CASH_BACK_AMOUNT_FRAGMENT } from './quoteCashBackAmountFragment';
import { QUOTE_EQUIPMENT_TRADE_INS_FRAGMENT } from './quoteEquipmentTradeInsFragment';

export const QUOTE_FIELDS_FRAGMENT = gql`
  fragment QuoteFields on Quote {
    term
    active
    quoteId
    feesTotal
    downPayment
    interestRate
    rebatesTotal
    paymentAmount
    tradeValueNet
    tradeValueOwed
    financedAmount
    tradeValueGross
    createdDateTime
    modifiedDateTime
    contractStartDate
    equipmentSubtotal
    daysToFirstPayment
    vendorOpportunityId
    firstPaymentDueDate
    cashBackAmountsTotal
    externalCrmVendorOpportunityId
    attributes {
      key
      value
      description
    }
    fees {
      ...QuoteFeeFields
    }
    aftermarketProducts {
      ...QuoteAftermarketProductFields
    }
    aftermarketProductsTotal
    rebates {
      ...QuoteRebateFields
    }
    cashBackAmounts {
      ...QuoteCashBackAmountFields
    }
    equipment {
      ...QuoteEquipmentFields
    }
    equipmentTradeIns {
      ...QuoteEquipmentTradeInsFields
    }
  }
  ${QUOTE_FEE_FRAGMENT}
  ${QUOTE_AFTERMARKET_PRODUCT_FRAGMENT}
  ${QUOTE_REBATE_FRAGMENT}
  ${QUOTE_CASH_BACK_AMOUNT_FRAGMENT}
  ${QUOTE_EQUIPMENT_FRAGMENT}
  ${QUOTE_EQUIPMENT_TRADE_INS_FRAGMENT}
`;
